import Modal from 'LuxKit/Modal/Modal'
import { useCallback, useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { semiFormToObject } from 'lib/forms/formUtils'
import useQueryParams from 'hooks/useQueryParams'
import Group from 'components/utils/Group'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import CruiseTravellerTypeFilter from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruiseTravellerTypeFilter'
import type {
  CruiseSearchTravellerTypeChipProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchTravellerTypeChip'

function ModalCruiseSearchTravellerTypeChip(props: CruiseSearchTravellerTypeChipProps) {
  const {
    facets,
    filterForm,
    setFilterForm,
    fetching,
    filters,
    drawerMode,
  } = props
  const intl = useIntl()
  const modalElement = useModalElementContext<number>()
  const containerRef = useRef<HTMLDivElement>(null)
  const queryParams = useQueryParams()

  const countSelected = useMemo(() => {
    return queryParams.getAll('travellerTypes').length
  }, [queryParams])

  const closeModal = useCallback(() => {
    modalElement.resolve(countSelected)
  }, [countSelected, modalElement])

  const updateForm = useCallback(() => {
    const formValues = semiFormToObject<Record<string, any>>(containerRef.current!)
    if (formValues && Object.keys(formValues).length > 0) {
      setFilterForm({
        ...filterForm,
        travellerTypes: formValues.travellerTypes,
      })
    } else {
      setFilterForm({
        ...filterForm,
        travellerTypes: undefined,
      })
    }
  }, [filterForm, setFilterForm])

  const resetFilter = useCallback(() => {
    setFilterForm({
      ...filterForm,
      travellerTypes: undefined,
    })
    modalElement.resolve(0)
  }, [filterForm, setFilterForm, modalElement])

  const modalTitle = intl.formatMessage({
    id: 'Pr75MGj-TkgrXHzqPslL',
    defaultMessage: 'Traveller Type',
  })
  const applyLabel = intl.formatMessage({
    id: '-CaRpOppo8I-EDtZ5zF1',
    defaultMessage: 'Apply',
  })
  const resetLabel = countSelected ?
      intl.formatMessage(
        {
          id: 'i0FN8zk1t74p0Rz1n9Wl',
          defaultMessage: 'Reset all ({count})',
        },
        { count: countSelected },
      ) :
      intl.formatMessage({
        id: 'l2a2CGY6bx8m9dlGf4Yr',
        defaultMessage: 'Reset all',
      })

  return <Modal
    mode={drawerMode ? 'drawer' : 'default'}
    ref={containerRef}
    title={modalTitle}
    primaryActionText={applyLabel}
    onPrimaryActionClick={closeModal}
    secondaryActionText={resetLabel}
    onSecondaryActionClick={resetFilter}
  >
    {fetching && <Group direction="vertical" gap={8}>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
    </Group>}
    {!fetching && <CruiseTravellerTypeFilter
      travellerTypes={filters.travellerTypes}
      travellerTypeFacets={facets.travellerTypes}
      onChange={updateForm}
    />}
  </Modal>
}

export default ModalCruiseSearchTravellerTypeChip
